import { SvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

interface AccountIconProps extends SvgIconProps {
  isPatientAccount?: boolean;
}

const AccountIcon: FC<AccountIconProps> = ({ isPatientAccount, ...props }) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {!isPatientAccount ? (
        <path
          d="M0.5 20.5C0.5 9.73045 9.23045 1 20 1C30.7696 1 39.5 9.73045 39.5 20.5C39.5 31.2696 30.7696 40 20 40C9.23045 40 0.5 31.2696 0.5 20.5Z"
          fill="#00B6B9"
          stroke="#00B6B9"
        />
      ) : null}
      <path
        d="M20 19.25C18.0586 19.25 16.5 17.6914 16.5 15.75C16.5 13.8359 18.0586 12.25 20 12.25C21.9141 12.25 23.5 13.8359 23.5 15.75C23.5 17.6914 21.9141 19.25 20 19.25ZM21.3672 20.5625C23.9922 20.5625 26.125 22.6953 26.125 25.3203C26.125 25.8398 25.6875 26.25 25.168 26.25H14.8047C14.2852 26.25 13.875 25.8398 13.875 25.3203C13.875 22.6953 15.9805 20.5625 18.6055 20.5625H21.3672Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default AccountIcon;
